import { render, staticRenderFns } from "./bo-price-display.vue?vue&type=template&id=155479ff&scoped=true"
import script from "./bo-price-display.vue?vue&type=script&lang=js"
export * from "./bo-price-display.vue?vue&type=script&lang=js"
import style0 from "./bo-price-display.vue?vue&type=style&index=0&id=155479ff&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155479ff",
  null
  
)

export default component.exports